






























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card } from '@alpha/ink'
import { Insight, Question, Option } from '@/store/modules/survey-store-module'
import { groupBy } from 'lodash-es'
import { SliceType } from '@shared/types/database'
import { DefaultLabelMap } from './QuestionTypes/VariantQuestion.vue'

export type AutomatedInsightObj = Insight & { question: Question}
export type AutomatedInsightVariantObj = Insight & { variantOptions: Option[] }
export type SliceTypeKey = keyof typeof SliceType

@Component({
  components: {
    Card
  }
})
export default class AutomatedInsights extends Vue {
  @Prop({ default: () => [] }) mainInsights!: AutomatedInsightObj[]
  @Prop({ default: () => [] }) demographicInsights!: AutomatedInsightObj[]
  @Prop({ default: () => [] }) variantInsights!: AutomatedInsightVariantObj[]

  get demoInsights () {
    return groupBy(this.demographicInsights, i => i.demographic)
  }

  get varInsights () {
    return groupBy(this.variantInsights, i => i.demographic)
  }

  buildInsightText (insight:AutomatedInsightObj): string | undefined {
    if (insight.type === 'Main') {
      return `When asked to users "${insight.question.configuration?.title || insight.question.text}" most users within the sample selected <b>${insight.option}</b>`
    } else if (insight.type === 'Demographic') {
      return `${this.formatDemographicOption(insight)} selected <b>${insight.option}</b> more frequently than other participants in this test.`
    }
  }

  buildVariantInsightText (insight: AutomatedInsightVariantObj) {
    const variantIndex = parseInt(insight.group!) - 1
    const group = insight.variantOptions[variantIndex].configuration?.title || insight.variantOptions[variantIndex].label || DefaultLabelMap[variantIndex]
    return `Participants part of <b>${group}</b> selected <b>${insight.option}</b> more frequently than other participants in this test.`
  }

  formatDemographicOption (insight:AutomatedInsightObj) {
    switch (insight.demographic) {
      case 'STANDARD_HHI_US':
        return `Participants with household income <b>${insight.group!.charAt(0).toLowerCase() + insight.group!.slice(1)}</b>`
      case 'AGE':
        return `Participants aged <b>${insight.group}</b>`
      case 'GENDER':
        return `<b>${insight.group}</b> participants`
      case 'STANDARD_EMPLOYMENT':
        return `<b>${insight.group}</b> participants`
      default:
        return `<b>${insight.group}</b>`
    }
  }

  formattedDemographic (demo: SliceTypeKey) {
    return SliceType[demo]
  }

  revealInsight (insight: AutomatedInsightObj | SliceTypeKey) {
    if (typeof insight === 'string') {
      this.$emit('revealInsight', this.formattedDemographic(insight))
    } else {
      this.$emit('revealInsight', insight)
    }
  }

  calcInfo (insight: AutomatedInsightObj) {
    return `alpha: ${insight.alpha}, mag: ${insight.magnitude}, relmag: ${insight.relMagnitudes},`
  }
}
